
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class ClientFunctionTriggerGrid extends SiteEntityGrid<ClientFunctionTriggerRow, any> {
        protected getColumnsKey() { return 'Workflow.ClientFunctionTrigger'; }
        protected getDialogType() { return ClientFunctionTriggerDialog; }
        protected getIdProperty() { return ClientFunctionTriggerRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFunctionTriggerRow.localTextPrefix; }
        protected getService() { return ClientFunctionTriggerService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}